export interface OtpInputFieldProps {
  name: string;
  requestId?: string;
  autoverify?: boolean;
}

export enum InputMode {
  NUMERIC = 'numeric',
  TEXT = 'text',
}
